import NullEditor from '@intercom/embercom-composer/components/null-editor';
export default NullEditor;
